import React from "react";
import { ReactComponent as DetachedHouse } from "../statics/icons/detached_house.svg";
import { ReactComponent as DetachedHouseUnderConstructionClosedState } from "../statics/icons/detached_house_under_construction_closed_state.svg";
import { ReactComponent as DetachedHouseUnderConstructionOpenState } from "../statics/icons/detached_house_under_construction_open_state.svg";
import { ReactComponent as Flat } from "../statics/icons/flat.svg";
import { ReactComponent as FlatUnderConstructionClosedState } from "../statics/icons/flat_under_construction_closed_state.svg";
import { ReactComponent as FlatUnderConstructionOpenState } from "../statics/icons/flat_under_construction_open_state.svg";
import { TileModel } from "./tile";

export enum PropertyTypeId {
  flat = "FLAT",
  flatUnderConstructionClosedState = "FLAT_UNDER_CONSTRUCTION_CLOSED_STATE",
  flatUnderConstructionOpenState = "FLAT_UNDER_CONSTRUCTION_OPEN_STATE",
  detachedHouse = "DETACHED_HOUSE",
  detachedHouseUnderConstructionClosedState = "HOUSE_UNDER_CONSTRUCTION_CLOSED_STATE",
  detachedHouseUnderConstructionOpenState = "HOUSE_UNDER_CONSTRUCTION_OPEN_STATE"
}

export const PropertyTypes: TileModel[] = [
  {
    id: PropertyTypeId.flat,
    displayName: "Mieszkanie",
    icon: <Flat className="icon-svg-color" />
  },
  {
    id: PropertyTypeId.detachedHouse,
    displayName: "Dom",
    icon: <DetachedHouse className="icon-svg-color" />
  },
  {
    id: PropertyTypeId.detachedHouseUnderConstructionClosedState,
    displayName: "Dom w budowie stan surowy zamknięty",
    icon: <DetachedHouseUnderConstructionClosedState className="icon-svg-color" />
  },
  {
    id: PropertyTypeId.detachedHouseUnderConstructionOpenState,
    displayName: "Dom w budowie stan surowy otwarty",
    icon: <DetachedHouseUnderConstructionOpenState className="icon-svg-color" />
  },
  {
    id: PropertyTypeId.flatUnderConstructionClosedState,
    displayName: "Mieszkanie w budowie stan surowy zamknięty",
    icon: <FlatUnderConstructionClosedState className="icon-svg-color" />
  },
  {
    id: PropertyTypeId.flatUnderConstructionOpenState,
    displayName: "Mieszkanie w budowie stan surowy otwarty",
    icon: <FlatUnderConstructionOpenState className="icon-svg-color" />
  }
];
